export default __webpack_public_path__ + "static/media/Frame 3214.65be9101.png";